import { Button, Form, Input } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { apiRoutes } from '../../routes/api';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../store/slices/adminSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { webRoutes } from '../../routes/web';
import { handleErrorResponse, setPageTitle } from '../../utils';
import { defaultHttp } from '../../utils/http';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || webRoutes.home;
  const admin = useSelector((state) => state.admin);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    setPageTitle('Admin Login');
  }, []);

  useEffect(() => {
    if (admin) {
      navigate(from, { replace: true });
    }
  }, [admin]);

  const onSubmit = (values) => {
    setLoading(true);

    defaultHttp
      .post(apiRoutes.login, {
        email: values.email,
        password: values.password,
      })
      .then((response) => {
        const admin = {
          token: response.data.data.accessToken,
          token_data: response.data.data,
          user: response.data.data.user,
        };
        dispatch(login(admin));
      })
      .catch((error) => {
        handleErrorResponse(error);
        setLoading(false);
      });
  };

  return (
    <>
      <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl text-left text-opacity-30 tracking-wide mb-4">Login to proceed</h1>
      <Form className="space-y-5" form={form} name="login" onFinish={onSubmit} layout={'vertical'} requiredMark={false} initialValues={{}}>
        <div>
          <Form.Item
            name="email"
            label={<p className="block text-sm font-medium text-gray-700 mb-2">Email</p>}
            rules={[
              {
                required: true,
                message: 'Please enter your email',
              },
              {
                type: 'email',
                message: 'Invalid email address',
              },
            ]}
          >
            <Input prefix={<MailOutlined className="text-gray-400 mr-2" />} placeholder="abc@gmail.com" className="py-3 px-4 text-base" style={{ borderRadius: '8px' }} />
          </Form.Item>
        </div>
        <div>
          <Form.Item
            name="password"
            label={<p className="block text-sm font-medium text-gray-700 mb-2">Password</p>}
            rules={[
              {
                required: true,
                message: 'Please enter your password',
              },
            ]}
          >
            <Input.Password prefix={<LockOutlined className="text-gray-400 mr-2" />} placeholder="••••••••" visibilityToggle={true} className="py-3 px-4 text-base" style={{ borderRadius: '8px' }} />
          </Form.Item>
        </div>

        <div className="text-right">
          <a href="/forgot-password" className="text-sm text-blue-600 hover:underline">
            Forgot your password?
          </a>
        </div>

        <div>
          <Button className="bg-primary h-14 text-lg" block loading={loading} type="primary" htmlType={'submit'}>
            Login
          </Button>
        </div>
      </Form>
    </>
  );
};

export default Login;
